<template>
  <v-dialog 
    v-model="activeMode"  
    max-width="800"
    @click:outside="closeForm()"
    :fullscreen="$vuetify.breakpoint.smAndDown"
  >
    <template v-slot:activator="{ on }">
      <a v-on="on">{{ id }} <v-icon small>mdi-launch</v-icon></a>
    </template>

    <v-progress-linear
      v-if="!customer"
      indeterminate
    ></v-progress-linear>

    <v-card v-else>
      <v-toolbar
        color="primary"
        dark
        flat
      >
        <v-toolbar-title>Карточка клиента №{{id}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="closeForm()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text>
        <v-row>
          <v-col cols="12" sm="6">
            <v-card cols="12" sm="6">
              <v-card-title>Общая информация</v-card-title>
              <v-card-text>
                <v-text-field
                  label="Дата создания"
                  :value="customer.createdAt | localDatetime"
                  disabled
                  filled
                ></v-text-field>
                <v-text-field
                  label="Дата редактирования"
                  :value="customer.updatedAt | localDatetime"
                  disabled
                  filled
                ></v-text-field>
                <v-text-field
                  label="Сайт"
                  :value="`${customer.site.name} (${customer.site.city.name})`"
                  disabled
                  filled
                ></v-text-field>
                <v-select
                  label="Статус"
                  v-model="customerObj.status"
                  :items="$store.state.customers.statuses"
                  filled
                  :disabled="loadingStatus"
                  :loading="loadingStatus"
                ></v-select>
                <v-textarea
                  label="Комментарий"
                  v-model="customerObj.comment"
                  :append-icon="customer.comment != customerObj.comment ? 'mdi-check': ''"
                  @click:append="saveComment()"
                  filled
                  :disabled="loadingComment"
                  :loading="loadingComment"
                ></v-textarea>
              </v-card-text>
            </v-card>

            <v-card cols="12" sm="6" class="mt-5">
              <v-card-title>Рекламная статистика</v-card-title>
              <v-card-text>
                <template v-if="customer.utm && customer.utm.source">
                  <p>
                    utm_source: {{customer.utm.source}}
                  </p>
                  <p v-if="customer.utm.medium">
                    utm_medium: {{customer.utm.medium}}
                  </p>
                  <p v-if="customer.utm.campaign">
                    utm_campaign: {{customer.utm.campaign}}
                  </p>
                  <p v-if="customer.utm.content">
                    utm_content: {{customer.utm.content}}
                  </p>
                  <p v-if="customer.utm.term">
                    utm_term: {{customer.utm.term}}
                  </p>
                </template>
                <template v-else>
                  UTM-метки не найдены.
                </template>
              </v-card-text>
            </v-card>

          </v-col>
          <v-col cols="12" sm="6">
            <v-card cols="12" sm="6">
              <v-card-title>
                Контакты
                <v-spacer></v-spacer>
                <v-btn icon v-if="!contactsEditMode" @click="contactsEditMode = true">
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
                <v-btn icon v-if="contactsEditMode" @click="saveContacts()">
                  <v-icon color="green">mdi-content-save-all</v-icon>
                </v-btn>
                <v-btn icon v-if="contactsEditMode" @click="discardContacts()">
                  <v-icon color="red">mdi-backup-restore</v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text>
                <v-form v-model="isValidContacts" ref="contactsForm" :disabled="loadingContacts || !contactsEditMode">
                <v-text-field
                  label="Имя"
                  v-model="customerObj.firstName"
                  filled
                ></v-text-field>
                <v-text-field
                  label="Отчество"
                  v-model="customerObj.middleName"
                  filled
                ></v-text-field>
                <v-text-field
                  label="Фамилия"
                  v-model="customerObj.lastName"
                  filled
                ></v-text-field>
                <v-text-field
                  label="Телефон *"
                  v-model="customerObj.phoneNumber"
                  prefix="+7"
                  filled
                  :disabled="true"
                ></v-text-field>
                <v-text-field
                  label="Email"
                  v-model="customerObj.email"
                  :rules="[v => !v || isEmail(v) || 'Введите правильный email.']"
                  filled
                ></v-text-field>
              </v-form></v-card-text>
            </v-card>
            <v-card class="mt-5">
              <v-card-title>Коммерческая информация</v-card-title>
              <v-card-text>
                <v-form ref="commercialForm" v-model="isValidCommercial">
                  <v-text-field
                    label="Сумма сметы"
                    append-icon="mdi-currency-rub"
                    v-model="commercialObj.estimateCost"
                    filled
                    :rules="[v => isNumber(v) || 'Введите число.']"
                  ></v-text-field>
                  <v-text-field
                    label="Сумма договора"
                    append-icon="mdi-currency-rub"
                    v-model="commercialObj.dealCost"
                    filled
                    :rules="[v => isNumber(v) || 'Введите число.']"
                  ></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions class="pa-0 ma-0 pb-2">
                <v-spacer></v-spacer>
                <v-btn color="primary" 
                  text 
                  dense 
                  @click="saveCommercial()"
                  :loading="loadingCommercial"
                  :disabled="loadingCommercial"
                >Сохранить</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
   
        <leads-table
          :leads="customer.leads"
          :singleCustomer="true"
        ></leads-table>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="closeForm()">Закрыть</v-btn>
      </v-card-actions>
    </v-card>

  </v-dialog>
</template>

<script>
import _ from 'lodash';
//import LeadsTable from './LeadsTable';

export default {
  name: 'customer-card',

  props: {
    id: {
      type: Number,
      required: true
    }
  },
  
  data() {
    return {
      activeMode: false,
      customer: null,
      customerObj: null,
      
      // commercial
      isValidCommercial: false,
      commercialObj: null,
      loadingCommercial: false,

      contactsEditMode: false,
      loadingStatus: false,
      loadingComment: false,
      loadingContacts: false,
      isValidContacts: false
    };
  },

  created() {
    
  },

  watch: {
    activeMode(val) {
      if (val) {
        this.$store.dispatch('customers/loadSingle', this.id)
        .then(res => {
          this.customer = res;
          this.customerObj = _.cloneDeep(res);
          this.commercialObj =  res.commercial ? _.cloneDeep(res.commercial) : null;
        })
        .catch(err => {
          this.$store.dispatch('showMessage', err.message);
          this.$nextTick(() => { this.activeMode = false; })
        });
      }
    },
    ['customerObj.status'](val) {
      if (this.customer && (val != this.customer.status)) {
        this.saveStatus();
      }
    }
  },

  methods: {
    async saveCommercial() {
      this.$refs.commercialForm.validate();
      if (this.isValidCommercial) {
        this.loadingCommercial = true;
        try {
          this.$store.dispatch('customers/update', { 
            _id: this.customer._id, 
            commercial: this.commercialObj
          });
          this.$store.dispatch('showMessage', 'Коммерческая информация успешно обновлена.');
        } catch(err) {
          this.$store.dispatch('showMessage', err.message);
        }
        finally {
          this.loadingCommercial = false;
        }
      }
    },

    saveStatus() {
      this.loadingStatus = true;
      this.$store.dispatch('customers/update', { _id: this.customer._id, status: this.customerObj.status })
      .then(res => {
        this.$store.dispatch('showMessage', 'Статус успешно обновлен.');
        this.customer.status = this.customerObj.status;
      })
      .catch(err => {
        this.$store.dispatch('showMessage', err.message);
      })
      .finally(() => {
        this.loadingStatus = false;
      });
    },
    saveComment() {
      this.loadingComment = true;
      this.$store.dispatch('customers/update', { _id: this.customer._id, comment: this.customerObj.comment })
      .then(res => {
        this.$store.dispatch('showMessage', 'Комментарий успешно обновлен.');
        this.customer.comment = this.customerObj.comment;
      })
      .catch(err => {
        this.$store.dispatch('showMessage', err.message);
      })
      .finally(() => {
        this.loadingComment = false;
      });
    },
    discardContacts() {
      this.customerObj.firstName = this.customer.firstName;
      this.customerObj.middleName = this.customer.middleName;
      this.customerObj.lastName = this.customer.lastName;
      this.customerObj.email = this.customer.email;
      this.$refs.contactsForm.resetValidation();
      this.contactsEditMode = false;
    },
    saveContacts() {
      this.$refs.contactsForm.validate();
      if (this.isValidContacts) {
        this.loadingContacts = true;
        this.$store.dispatch('customers/update', { 
          _id: this.customer._id, 
          firstName: this.customerObj.firstName,
          middleName: this.customerObj.middleName,
          lastName: this.customerObj.lastName,
          email: this.customerObj.email 
        })
        .then(res => {
          this.$store.dispatch('showMessage', 'Контакты успешно обновлены.');
          this.customer.firstName = this.customerObj.firstName;
          this.customer.lastName = this.customerObj.lastName;
          this.customer.middleName = this.customerObj.middleName;
          this.customer.email = this.customerObj.email;
          this.contactsEditMode = false;
        })
        .catch(err => {
          this.$store.dispatch('showMessage', err.message);
        })
        .finally(() => {
          this.loadingContacts = false;
        });
      }
    },
    closeForm() {
      this.discardContacts();
      this.customer.status = this.customerObj.status;
      this.customer.comment = this.customerObj.comment;
      this.activeMode = false;
    },
  }
}
</script>